// extracted by mini-css-extract-plugin
module.exports =  {"root":"Breadcrumbs-module__root--yZTtN","separator":"Breadcrumbs-module__separator--gjS3T","button":"Breadcrumbs-module__button--xUwv2"};